import React from "react";
// @mui
import { Link, Stack, Typography } from "@mui/material";
// routes
import { RouterLink } from "src/routes/components";
import { paths } from "src/routes/paths";
// sections
import { useBillingBalance } from "src/sections/billing/hook/use-billing-balance";
// utils
import { fCurrency } from "src/utils/format-number";

// ----------------------------------------------------------------------

export default function BalanceDisplay() {
    const { balance } = useBillingBalance();

    return (
        <Stack
              sx={ {
                  padding: "6px",
                  "&.MuiLink-root:hover": { textDecoration: "none", backgroundColor: "rgba(56, 69, 89, 0.08)", borderRadius: "8px" }
              } }
        >
            <Stack alignItems="center" px="6px">
                <Typography variant="body1" color="text.primary">
                    { `Balance: ` }

                    <Typography component="span" variant="body2" color={ ( balance && balance < 0 ) ? "error.main" : "text.primary" }>{ fCurrency(balance) }</Typography>
                </Typography>
            </Stack>
        </Stack>
    );
}
